export default __webpack_public_path__ + "camera.asset.5bde762ef11fbf2832d0759789abcb54.svg";